import { useEffect, useState } from "react";
import { WeeklyPage } from "../components/WeeklyPage";
import {
  query,
  collection,
  where,
  limit,
  getDocs,
  orderBy,
} from "firebase/firestore";
import { fireStore } from "../../../../firebase";
import moment from "moment";
import { TextArea } from "@blueprintjs/core";
import { previousFridayRange } from "../util";
import { useChartDateContext } from "../chart-date-context";
import { WeeklyHeader } from "../components/WeeklyHeader";

export const PageStockEnter = ({
  list,
  data,
  pageIndex,
  subIndex,
  registerPageIndex,
  details,
  save_key,
  weekData,
  onPageDataUpdated,
}: any) => {
  const [header, setHeader] = useState<any>(weekData?.[save_key]?.header ?? "");
  const [exitPerformans, setExitPerformans] = useState<any>({});
  const { chartDate } = useChartDateContext();

  const getLasFridayForStock = (stock: string) => {
    const { previousFriday, range } = previousFridayRange(chartDate);

    const q = query(
      collection(fireStore, "NS_LINES_1W_P4"),
      orderBy("date", "desc"),
      where("date", ">", previousFriday.toDate()),
      where("date", "<", range.toDate()),
      limit(1)
    );

    return getDocs(q).then((querySnapshot: any) => {
      const doc = querySnapshot.docs[0];

      return doc.data()[`lines0${list}`]?.find(
        (x: any) => x.symbol === stock
      )?.price;
    });
  };
  const getPreviousFridayForStock = (stock: string) => {
    const { previousFriday, range } = previousFridayRange(chartDate);

    const q = query(
      collection(fireStore, "NS_LINES_1W_P4"),
      orderBy("date", "desc"),
      where("date", ">", previousFriday.toDate()),
      where("date", "<", range.toDate()),
      limit(1)
    );

    return getDocs(q).then((querySnapshot: any) => {
      const doc = querySnapshot.docs[0];

      return doc.data()[`lines0${list}`]?.find(
        (x: any) => x.symbol === stock
      )?.price;
    });
  };
  const calcExitPerf = async (stock: string) => {
    const lastPrice = await getLasFridayForStock(stock);
    const previousPrice = await getPreviousFridayForStock(stock);
    return (lastPrice - previousPrice) / previousPrice;
  };

  useEffect(() => {
    if (details && data) {
      data?.outgoing?.map(async (stock: string) => {
        const detail = details.find((item: any) => item.symbol === stock);
        if (detail && detail.outgoing) {
          try {
            exitPerformans[stock] = parseFloat(detail.perClose) / 100;
          } catch (e) {}
        }
      });
    }
  }, [details, chartDate]);
  useEffect(() => {
    registerPageIndex(pageIndex, subIndex, `Bist ${list} Giriş`);
  }, []);
  return (
    <WeeklyPage pageId={`page-${pageIndex}-${subIndex}`}>
      <WeeklyHeader title="HAFTALIK SENTİMENT DEĞERLENDİRMESİ" />

      <div style={{ display: "flex", gap: 10 }}>
        <div
          style={{
            width: "50%",
            paddingInline: "10px",
            fontSize: "18px",
            fontWeight: "500",
          }}
        >
          <div
            style={{
              backgroundColor: "#F7AF3D",
              padding: "5px 10px",
              marginBottom: "10px",
              fontWeight: "600",
              borderRadius: "2px",
            }}
          >
            Bist {list} Haftalık Yedili Değerlendirmesi
          </div>
          <div>
            Bu hafta Bist {list} Haftalık Sentiment tarafında{" "}
            {data?.outgoing?.length} hissenin 7'li listeden çıkıp,{" "}
            {data?.incoming?.length} hissenin girdiğini görüyoruz.
            <TextArea
              style={{ width: "100%", height: 100 }}
              defaultValue={header}
              onChange={(e) => {
                setHeader(e.target.value);
                onPageDataUpdated(save_key, "header", e.target.value);
              }}
              className="no-print"
              placeholder="Başlık için eklenti yapabilirsiniz"
            ></TextArea>{" "}
            <span className="print-only-inline">{header ?? null}</span>
          </div>
          <div style={{ marginTop: 10, fontWeight: "600" }}>
            BIST {list} Haftalık Yedilisine {data?.incoming?.join(", ") + " "}{" "}
            girerken, {data?.outgoing?.join(", ") + " "}
            ilk 7 sırasındaki yerini kaybediyor.
          </div>
          <div style={{ marginTop: 20, textAlign: "left", fontWeight: "600" }}>
            Listelerden çıkış performansları aşağıdaki gibidir.
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridAutoFlow: "column",
                gridTemplateRows: "repeat(3, auto)",
                marginTop: 10,
              }}
            >
              {data?.outgoing?.map((stock: string) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      justifyContent: "left",
                      marginTop: 0,
                    }}
                  >
                    <span>{stock}</span>
                    <span
                      style={{
                        color: exitPerformans[stock] > 0 ? "green" : "red",
                      }}
                    >
                      %
                      {exitPerformans[stock]
                        ? (exitPerformans[stock] * 100).toFixed(2)
                        : ""}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{ marginTop: 10, textAlign: "left", fontWeight: "600" }}>
            Geçtiğimiz hafta ilk 7 listesine giren hisselerin performansları:
          </div>
          <div
            style={{
              textAlign: "left",
              marginTop: 10,
              fontWeight: "600",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gridAutoFlow: "column",
              gridTemplateRows: "repeat(3, auto)",
            }}
          >
            {details
              ?.filter((stock: any) => {
                return stock.lastIncoming === true;
              })
              .map((stock: any) => (
                <div
                  style={{ display: "flex", gap: 10, justifyContent: "left" }}
                >
                  <span>{stock.symbol}</span>{" "}
                  <span
                    style={{
                      color: parseFloat(stock.perClose) > 0 ? "green" : "red",
                    }}
                  >
                    %{stock.perClose}
                  </span>
                </div>
              ))}
          </div>
        </div>
        <div
          style={{
            width: "50%",
            paddingInline: "15px",
            display: "flex",
            flexDirection: "column",
            fontSize: "18px",
            fontWeight: "600",
            gap: 24,
          }}
        >
          <div>
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                fontWeight: "600",
                marginBottom: "6px",
                borderRadius: "2px",
              }}
            >
              Mevcut Bist {list} Haftalık Yedili Listesi
            </div>
            <div className="weekly-chip-container">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: 24,
                }}
              >
                {data?.basket.map((stock: string) => {
                  let backColor = "rgba(40,0,239,0.1)";
                  let borderColor = "rgb(40,0,239)";
                  let fontColor = "black";

                  return (
                    <div
                      className="weekly-chip"
                      style={{
                        fontSize: "18px",
                        backgroundColor: backColor,
                        color: fontColor,
                        borderWidth: 1,
                        borderColor: borderColor,
                        borderStyle: "solid",
                      }}
                    >
                      {stock}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              gap: 24,
            }}
          >
            <div style={{ width: "100%" }}>
              <div
                style={{
                  backgroundColor: "#F7AF3D",
                  padding: "5px 10px",
                  fontWeight: "600",
                  marginBottom: "10px",
                  borderRadius: "2px",
                }}
              >
                Listeye Girenler
              </div>
              <div className="weekly-chip-container">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "24px",
                  }}
                >
                  {data?.incoming?.map((stock: string) => {
                    let backColor = "rgba(60,170,129,0.1)";
                    let fontColor = "black";
                    let borderColor = "rgb(60,170,129)";

                    return (
                      <div
                        className="weekly-chip"
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          backgroundColor: backColor,
                          color: fontColor,
                          borderWidth: 1,
                          borderColor: borderColor,
                          borderStyle: "solid",
                        }}
                      >
                        {stock}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  backgroundColor: "#F7AF3D",
                  padding: "5px 10px",
                  fontWeight: "600",
                  marginBottom: "10px",
                  borderRadius: "2px",
                }}
              >
                Listeden Çıkanlar
              </div>
              <div className="weekly-chip-container">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "24px",
                  }}
                >
                  {data?.outgoing?.map((stock: string) => {
                    let backColor = "rgba(236,82,74,0.1)";
                    let fontColor = "black";
                    let borderColor = "rgb(236,82,74)";

                    return (
                      <div
                        className="weekly-chip"
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          backgroundColor: backColor,
                          color: fontColor,
                          borderWidth: 1,
                          borderColor: borderColor,
                          borderStyle: "solid",
                        }}
                      >
                        {stock}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WeeklyPage>
  );
};
